import React, { ReactNode } from 'react';
import { createGenericModalContext } from '../../../../../components/BasicComponents/GenericModalContext';
import DialogDetalheCooperado from './DialogDetalheCooperado';
import { DetalhePublicoProvider } from '../../../../../contexts/DialogsContext/DetalhePublicoContext';

const { GenericModalProvider, useGenericModal } = createGenericModalContext<string>();

export const ModalDetalheCooperadoProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    return (
        <DetalhePublicoProvider>
            <GenericModalProvider
                ModalComponent={DialogDetalheCooperado}
                urlParam="detalhe-cooperado"
            >
                {children}
            </GenericModalProvider>
        </DetalhePublicoProvider>
    );
};

export const useModalDetalheCooperado = useGenericModal;